import classnames from 'classnames';
import React, { useCallback } from 'react';
import { IoIosCheckmark as TickIcon } from 'react-icons/io';
import { createUseStyles } from 'react-jss';
import { useDispatch, useSelector } from 'react-redux';

import { useGame } from '../../../context';
import { toggleFilter } from '../../../redux/actions';

const useStyles = createUseStyles({
  button: {
    borderRadius: 4,
    composes: [
      'is-block',
      'mt6',
      'fs12',
      'py6',
      'is-full-width',
      'text-center',
    ],
    transition: 'background 0.3s, color 0.3s',
  },
  icon: {
    marginRight: 6,
    transition: 'color 0.3s',
    verticalAlign: 'middle',
  },
});

const RegionsFilterComponent = React.memo(() => {
  const classes = useStyles();
  const { regions } = useGame();
  const dispatch = useDispatch();
  const filters = useSelector(_ => _.filters);

  const clickHandler = useCallback(
    (types, visible) => dispatch(toggleFilter(types, visible)),
    [dispatch]
  );

  return regions.map(obj => {
    const hidden = filters.includes(obj.id);
    return (
      <button
        key={obj.id}
        className={classnames(
          classes.button,
          { hidden },
          'smart-maps-buttons-filter'
        )}
        type="button"
        onClick={() => clickHandler([obj.id], !hidden)}>
        <TickIcon className={classes.icon} size={22} />
        <i>{obj.label}</i>
      </button>
    );
  });
});

RegionsFilterComponent.displayName = 'RegionsFilterComponent';

export default RegionsFilterComponent;
